const PARAGRAPH_KEY = 'paragraph';

const ALIGN_LEFT = 'left';
const ALIGN_CENTER = 'center';
const ALIGN_RIGHT = 'right';

const VALID_ALIGNMENTS = [ALIGN_LEFT, ALIGN_CENTER, ALIGN_RIGHT];

const sanitizeParagraphNode = (node) => {

	const { align } = node.attrs;

	let safeAlignment = ALIGN_LEFT;

	// Check to make sure that the alignment is valid...
	if (VALID_ALIGNMENTS.indexOf(align) >= 0) {
		safeAlignment = align;
	}

	const safeAttrs = {
		align: safeAlignment,
	};

	node.attrs = safeAttrs;

	return node;

};

const ParagraphNodeSpec = {
	attrs: {
		align: {
			default: ALIGN_LEFT,
		},
	},
	content: 'inline*',
	group: 'block',
	parseDOM: [{
		tag: 'p',
		getAttrs(dom) {

			let align = ALIGN_LEFT;

			const style = dom.getAttribute('style');

			if (style) {

				if (style.includes(`text-align: '${ALIGN_LEFT};`)) {

					align = ALIGN_LEFT;

				} else if (style.includes(`text-align: '${ALIGN_CENTER};`)) {

					align = ALIGN_CENTER;

				} else if (style.includes(`text-align: '${ALIGN_RIGHT};`)) {

					align = ALIGN_RIGHT;

				}

			}

			return { align };

		},
	}],
	toDOM(node) {

		const safeNode = sanitizeParagraphNode(node);

		const { align } = safeNode.attrs;

		const style = `text-align: ${align};`;

		return ['p', { style }, 0];

	}
};

module.exports = {
	ParagraphNodeSpec,
	PARAGRAPH_KEY,
	ALIGN_LEFT,
	ALIGN_CENTER,
	ALIGN_RIGHT,
	sanitizeParagraphNode,
};
